export default "__VITE_ASSET__MkrBpnPd__"